import EmailPhoneOtpModal from "./EmailPhoneOtpModal";
import { FLOW_TYPES } from "@/constants/modals/FlowTypes";

const UnsubscribeModalTwo = ({ className, onClose, fromWhere = "" }) => {
 return (
    <EmailPhoneOtpModal
      className={className}
      onClose={onClose}
      fromWhere={fromWhere}
      flowType={FLOW_TYPES.UNSUBSCRIBE}
      />
  );
};

export default UnsubscribeModalTwo;